import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteLabelTemplate } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default graphql(mutationDeleteLabelTemplate)(
  class DeleteButton extends Component {
    static propTypes = {
      id: PropTypes.number,
      refetch: PropTypes.func
    };
    state = { showModal: false };

    render() {
      return [
        <Icon
          key="trash"
          name="recycle-bin"
          onClick={() => this.setState({ showModal: true })}
          {...this.props}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text="Do you want to delete this label?"
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = async () => {
      const { id, refetch, mutate } = this.props;
      try {
        await mutate({
          variables: {
            labels: [{ id: id }]
          }
        });
        refetch();
        this.setState({ showModal: false });
        ShowNotice("label-template-delete-success");
      } catch (error) {
        ShowNotice("label-template-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/label-panel/DeleteButtonWithMutation.js